import { Box, Typography } from '@mui/material';
const Fieldset = ({
  title,
  color = 'inherit',
  titleSize = '1rem',
  borderWidth = 1,
  borderRadius = 2,
  children,
  sx = {},
  ...props
}) => {
  return (
    <Box
      component="fieldset"
      sx={{
        //borderColor: color,
        //borderOpacity: "0.1",
        //border: "1px solid grey",
        border: '1px solid rgba(125,125,125,0.2)',
        borderWidth: borderWidth,
        borderRadius: borderRadius,
        padding: '15px',
        marginTop: '5px',
        marginBottom: '10px',
        ...sx,
      }}
      {...props}
    >
      {title && (
        <Typography
          component="legend"
          sx={{
            color: color,
            fontSize: titleSize,
            paddingLeft: '12px',
            paddingRight: '12px',
            opacity: '0.7',
          }}
        >
          {title}
        </Typography>
      )}
      {children}
    </Box>
  );
};

export default Fieldset;
